import React from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import SocietyCard from './SocietyCard'

interface FeaturedSocietiesData {
  allMdx: {
    nodes: Array<{
      id: string
      frontmatter: {
        title: string
        image?: string
        featured?: boolean
        tags?: string[]
      }
      fields: {
        slug: string
      }
    }>
  }
}

const FeaturedSocieties: React.FC = () => {
  const data = useStaticQuery<FeaturedSocietiesData>(graphql`
    query FeaturedSocietiesQuery {
      allMdx(
        filter: {
          internal: { contentFilePath: { regex: "/content/societies/" } }
          frontmatter: { featured: { eq: true } }
        }
        sort: { frontmatter: { title: ASC } }
        limit: 3
      ) {
        nodes {
          id
          frontmatter {
            title
            image
            featured
            tags
          }
          fields {
            slug
          }
        }
      }
    }
  `)

  const societies = data.allMdx.nodes

  if (societies.length === 0) {
    return null // Don't show the section if no featured societies
  }

  return (
    <div className="featured-societies-section">
      <div className="flex justify-between items-center mb-6">
        <h1 className="my-0">Featured Societies</h1>
        <Link to="/societies" className="text-primary font-medium hover:underline inline-block">
          See more →
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {societies.map((society, index) => (
          <SocietyCard
            key={society.id}
            title={society.frontmatter.title}
            image={society.frontmatter.image}
            slug={society.fields.slug}
            tags={society.frontmatter.tags}
            className={index === 2 ? 'hidden lg:block' : ''}
          />
        ))}
      </div>
    </div>
  )
}

export default FeaturedSocieties